import { forwardRef, type Ref, type SVGProps } from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const PRIMARY_COLOR = "var(--angelou-svg-primary-color, #1D1D1D)";

/**
 * Writing tool icon, drawn on the same 32x32 grid as Angelou's icons and colored with
 * Angelou's primary SVG color so it can be passed to `<Icon SvgComponent />`.
 */
const WritingToolIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M7 15H4.5C4.22386 15 4 15.2239 4 15.5V19.5C4 19.7761 4.22386 20 4.5 20H8"
      stroke={PRIMARY_COLOR}
      strokeWidth={2}
    />
    <path
      d="M24 20L27.5 20C27.7761 20 28 19.7761 28 19.5L28 15.5C28 15.2239 27.7761 15 27.5 15L25 15"
      stroke={PRIMARY_COLOR}
      strokeWidth={2}
    />
    <rect
      x={7}
      y={8}
      width={18}
      height={17}
      rx={8.5}
      stroke={PRIMARY_COLOR}
      strokeWidth={2}
    />
    <path
      d="M17.5 12C19.9853 12 22 14.0147 22 16.5C22 18.9853 19.9853 21 17.5 21H14.5C12.0147 21 10 18.9853 10 16.5C10 14.0147 12.0147 12 14.5 12H17.5ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H13ZM19 14C18.4477 14 18 14.4477 18 15C18 15.5523 18.4477 16 19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14Z"
      fill={PRIMARY_COLOR}
    />
    <path d="M12 24L10 29" stroke={PRIMARY_COLOR} strokeWidth={2} />
    <path d="M20 24L22 29" stroke={PRIMARY_COLOR} strokeWidth={2} />
    <path
      d="M26 15V8L24 3L22 8V10"
      stroke={PRIMARY_COLOR}
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path d="M22 8L24 3L26 8H22Z" fill={PRIMARY_COLOR} />
    <path
      d="M10 23H7.5C6.67157 23 6 23.6716 6 24.5V28.5C6 28.7761 6.22386 29 6.5 29H25.5C25.7761 29 26 28.7761 26 28.5V24.5C26 23.6716 25.3284 23 24.5 23H22"
      stroke={PRIMARY_COLOR}
      strokeWidth={2}
    />
  </svg>
);

export default forwardRef(WritingToolIcon);
